import { ReactNode } from 'react';
import BarraFiltros from '@/components/paineis/filtros/BarraFiltros';
import type { EquiplexSnapshotResponse, RecortePainel } from '@/types/dashboards';
import { useCatalogoProdutos } from './useCatalogoProdutos';
import { useFiltroPaineis } from './useFiltroPaineis';
import { usePainelEquiplex, type EstadoPainelEquiplex } from './usePainelEquiplex';

export interface PainelFiltrado<P> {
  estado: EstadoPainelEquiplex<P>;
  /**
   * A barra de filtros, com o recorte que o servidor aplicou (vem no payload), o que a aba
   * diz que não usa do filtro (a DRE: mês de produção e produto) e o último dia com dado (o aviso
   * de começo de mês).
   */
  barra: (recorte?: RecortePainel, naoSeAplica?: string[], dadosAte?: string | null) => ReactNode;
}

/**
 * Aba do painel com o filtro de período e produto: lê o filtro da URL, busca a aba com ele e
 * monta a barra. `buscar` precisa ser estável (função de módulo), como no `usePainelEquiplex`.
 */
export function usePainelFiltrado<P>(
  buscar: (params: Record<string, string>) => Promise<EquiplexSnapshotResponse<P>>,
): PainelFiltrado<P> {
  const { filtro, params, definir, limpar } = useFiltroPaineis();
  const catalogo = useCatalogoProdutos();
  const estado = usePainelEquiplex<P>(buscar, params);
  const barra = (recorte?: RecortePainel, naoSeAplica?: string[], dadosAte?: string | null) => (
    <BarraFiltros
      naoSeAplica={naoSeAplica}
      dadosAte={dadosAte}
      filtro={filtro}
      onChange={definir}
      onLimpar={limpar}
      recorte={recorte}
      catalogo={catalogo}
      recalculando={estado.recalculando}
      erro={estado.erroFiltro}
      indisponivel={!!estado.resposta?.recorte_indisponivel}
    />
  );
  return { estado, barra };
}
